export const PHONE_VERIFY = {
  MOBILE_NUMBER : '18435930001',
  VERIFY_CODE : 1111
};